/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  tacticalCards_Container: {
    width: '100%',
    ml: '-8px',
    mb: 4,
    p: 1,
    justifyContent: 'center',
  },
  tacticalCard_SkeletonContent: {
    ml: 1,
    width: '100%',
    mt: 2,
  },
  tactOfferContainer: {
    p: '0 2.2rem !important',
    [theme.breakpoints.down('md')]: {
      p: '0 !important',
    },
  },
  tactical_cards: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    position: 'relative',
    width: '100%',
  },
  tacticalCard_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingLeft: 2,
    paddingRight: 2,
  },
  tacticalCard_Heading: {
    paddingTop: 2,
    paddingRight: 0.5,
    lineHeight: '1.5rem',
    color: theme.palette.primary.textColor3,
  },
  tacticalCard_Body: {
    paddingRight: 0.5,
    pt: 0.5,
    color: theme.palette.primary.textColor3,
  },
});

export default styles;
